// «Владелец протоколов» (041: T020, T022; FR-004; contracts/ui.md 041, «Пользователи → карточка»,
// «Профиль»): протоколы, которыми пользователь владеет, — «П-1 · Планёрка корпуса» ссылками
// на протокол, по номеру П-N. Первые 10; дальше — «и ещё N» в «Документы». Эталон — Settings →
// Members в gr8r-studio: список строк в рамке, как «Доступ к протоколам» (023) рядом.
// «и ещё N» открывает «Документы» с фильтром «Владелец» (?lead=<id>).
import { Link } from '@tanstack/react-router';

export const OWNED_PROTOCOLS_TITLE = 'Владелец протоколов';

/** Сколько протоколов видно списком: остальные — «и ещё N» (contracts/ui.md 041). */
export const OWNED_PROTOCOLS_SHOWN = 10;

export interface OwnedProtocol {
  documentId: string;
  number: number;
  title: string;
}

/** «П-1 · Планёрка корпуса». */
export function ownedProtocolLabel(protocol: Pick<OwnedProtocol, 'number' | 'title'>): string {
  return `П-${protocol.number} · ${protocol.title}`;
}

/** По номеру П-N: так их перечисляют и окно архива, и «Документы». */
export function byNumber<T extends Pick<OwnedProtocol, 'number'>>(protocols: readonly T[]): T[] {
  return [...protocols].sort((a, b) => a.number - b.number);
}

/**
 * Номера через запятую, первые 10 и «и ещё N»: «П-1, П-3» — для окна архива (contracts/ui.md 041:
 * «Протоколы перейдут другому владельцу: П-1, П-3»).
 */
export function ownedNumbersText(protocols: readonly Pick<OwnedProtocol, 'number'>[]): string {
  const sorted = byNumber(protocols);
  const shown = sorted
    .slice(0, OWNED_PROTOCOLS_SHOWN)
    .map((protocol) => `П-${protocol.number}`)
    .join(', ');
  const more = sorted.length - OWNED_PROTOCOLS_SHOWN;
  return more > 0 ? `${shown} и ещё ${more}` : shown;
}

/** Список протоколов владельца ссылками; пустой список не рисуется. */
export function OwnedProtocolList({
  protocols,
  ownerId,
}: {
  protocols: readonly OwnedProtocol[];
  /** Чьи протоколы: «и ещё N» — «Документы» с фильтром «Владелец». */
  ownerId: string;
}) {
  if (protocols.length === 0) return null;
  const sorted = byNumber(protocols);
  const more = sorted.length - OWNED_PROTOCOLS_SHOWN;
  return (
    <>
      <ul className="kp-list" aria-label={OWNED_PROTOCOLS_TITLE}>
        {sorted.slice(0, OWNED_PROTOCOLS_SHOWN).map((protocol) => (
          <li key={protocol.documentId} className="kp-list-row">
            <Link to="/protocols/$id" params={{ id: protocol.documentId }} className="kp-link">
              {ownedProtocolLabel(protocol)}
            </Link>
          </li>
        ))}
      </ul>
      {more > 0 ? (
        <p className="kp-set-more">
          <Link
            to="/documents"
            search={{ lead: ownerId }}
            className="kp-link"
            aria-label={`и ещё ${more} — все протоколы в «Документах»`}
          >
            и ещё {more}
          </Link>
        </p>
      ) : null}
    </>
  );
}
